import React, { useState } from 'react';
import { getUserContact } from '../services/userService';
import { ref, get } from 'firebase/database';
import { database } from '../firebaseConfig';
import { isLimitedAgent, LIMITED_AGENT_COAGENT } from '../config/roleAccess';

// Agent quick action: text the client (or every contact on the deal) asking for a Google review.
// The message is editable. The agent's Google Business Profile link comes from their profile.
const isReviewTask = (name) => /^MANUAL SEND - Text Asking for Google Review/i.test(name || '');

const digitsOf = (p) => String(p || '').replace(/[^0-9+]/g, '');

const reviewText = (names, link) => `Hey ${names}! It was a joy working with you! Congratulations on your closing! It would mean the world to me if you would take a few minutes to write me a five star Google review. It's so important in helping clients find me online. Here's the link: ${link}

I really appreciate it!`;

export default function GoogleReviewQuickText({ task, deal, ownerUid, onSent }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [body, setBody] = useState('');
  const [link, setLink] = useState('');
  const [pick, setPick] = useState('all');

  if (!isReviewTask(task?.name || task?.title)) return null;

  const contacts = [
    { name: deal?.firstName || '', phone: deal?.phone || '' },
    ...((deal?.additionalContacts || []).filter(c => c && (c.firstName || c.phone)).map(c => ({ name: c.firstName || '', phone: c.phone || '' }))),
  ].filter(c => c.name || c.phone);
  const chosen = pick === 'all' ? contacts : contacts.filter((_, i) => String(i) === String(pick));
  const numbers = chosen.map(c => digitsOf(c.phone)).filter(Boolean);
  const names = chosen.map(c => c.name).filter(Boolean);
  const greeting = names.length > 1 ? `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}` : (names[0] || 'there');

  const btn = { display: 'inline-block', padding: '8px 14px', borderRadius: 6, fontWeight: 700, fontSize: 13, textDecoration: 'none', border: '1px solid #B8962E', background: '#B8962E', color: '#FFFFFF', cursor: 'pointer', marginRight: 8 };
  const btnCancel = { ...btn, background: '#FFFFFF', color: '#5B6270', borderColor: '#D5D9E0' };

  const toggle = async () => {
    if (open) { setOpen(false); return; }
    setLoading(true);
    try {
      // A Limited Agent's deals ask for reviews for the lead agent (Kelly), with her link.
      const ownerRole = ownerUid ? await get(ref(database, `users/${ownerUid}/role`)).then((s) => s.val()).catch(() => null) : null;
      const linkUid = isLimitedAgent(ownerRole) ? LIMITED_AGENT_COAGENT.uid : ownerUid;
      const agent = linkUid ? await getUserContact(linkUid).catch(() => null) : null;
      const profileLink = agent?.googleBusinessUrl || '[Google Business Profile link]';
      setLink(profileLink);
      setBody(reviewText(greeting, profileLink));
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const done = () => { if (onSent) onSent(); };

  // Changing who gets the text rebuilds the greeting. Any edits to the message are replaced, so it is reset to the default wording.
  const choose = (value) => {
    setPick(value);
    const picked = value === 'all' ? contacts : contacts.filter((_, i) => String(i) === String(value));
    const pickedNames = picked.map(c => c.name).filter(Boolean);
    const who = pickedNames.length > 1 ? `${pickedNames.slice(0, -1).join(', ')} and ${pickedNames[pickedNames.length - 1]}` : (pickedNames[0] || 'there');
    setBody(reviewText(who, link || '[Google Business Profile link]'));
  };

  return (
    <div style={{ marginTop: 8, padding: 10, border: '1px solid #E5E0D3', borderRadius: 6, background: '#FFFFFF' }}>
      <div style={{ fontSize: 13, color: '#1A1A1A', fontWeight: 600, marginBottom: 6 }}>
        Text to: {contacts.length ? contacts.map(c => c.name || c.phone).join(', ') : 'No contacts saved on this deal'}
      </div>
      {contacts.length > 1 && (
        <select value={pick} onChange={(e) => choose(e.target.value)} style={{ padding: 6, fontSize: 13, marginBottom: 8 }}>
          <option value="all">Everyone on this deal</option>
          {contacts.map((c, i) => (
            <option key={i} value={String(i)}>{c.name || c.phone}</option>
          ))}
        </select>
      )}
      <button type="button" onClick={toggle} disabled={loading} style={btn}>
        {loading ? 'Loading...' : open ? 'Hide text' : 'Review and send review request'}
      </button>
      {open && (
        <div style={{ marginTop: 10 }}>
          <textarea value={body} onChange={(e) => setBody(e.target.value)} rows={8} style={{ width: '100%', boxSizing: 'border-box', padding: 8, fontSize: 13 }} />
          <div style={{ marginTop: 8 }}>
            {numbers.length > 0 && <a href={`sms:${numbers.join(',')}?body=${encodeURIComponent(body)}`} onClick={done} style={btn}>Send text</a>}
            <button type="button" onClick={() => setOpen(false)} style={btnCancel}>Cancel</button>
          </div>
          {numbers.length === 0 && <div style={{ fontSize: 12, color: '#5B6270', marginTop: 6 }}>No phone number saved for the clients on this deal.</div>}
        </div>
      )}
    </div>
  );
}
